export default __webpack_public_path__ + "static/sizzle_desktop-5751b8068da9aa8cc5afb13ace0ae39b.mp4";